import socketIOClient from "socket.io-client";
// import { BASE_URL } from "./helper";
const socketEndPoint = process.env.REACT_APP_API_ENDPOINT;

const socket = socketIOClient(socketEndPoint, { forceNew: true });
socket.connect();

export default socket;
